import { toSmartScheduleKst } from '../smartSchedule/date';
import type { SmartScheduleEvent } from '../smartSchedule/types';
import { findQuickMoveReplacement } from './plan';
import type { QuickMoveSavePlan, QuickMoveSource } from './types';

/** 같은 강사의 반개구간 충돌. 안내용이며 저장 가능 여부는 서버가 최종 판정한다. */
export const findQuickMoveOverlaps = (
    source: Pick<QuickMoveSource, 'scheduleId' | 'coachId'>,
    target: { startTime: string; endTime: string },
    events: SmartScheduleEvent[],
    savedPlan?: QuickMoveSavePlan
): SmartScheduleEvent[] => {
    const start = toSmartScheduleKst(target.startTime).valueOf();
    const end = toSmartScheduleKst(target.endTime).valueOf();
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return [];
    const replacementId = savedPlan ? findQuickMoveReplacement(savedPlan, events)?.id : undefined;

    return events.filter((event) => {
        if (event.coachId !== source.coachId || event.id === source.scheduleId || event.id === replacementId) return false;
        const eventStart = toSmartScheduleKst(event.startTime).valueOf();
        const eventEnd = toSmartScheduleKst(event.endTime).valueOf();
        return eventEnd > eventStart && eventStart < end && start < eventEnd;
    });
};
